import React from 'react';
import {observer} from 'mobx-react';

import {Col, DatePicker, Row} from "antd";

import MySearchComponent from '@ViewsDashboard/Common/MySearchComponent';

import Genera_store, {filter_store} from '@store/Statistic/GeneraCharge/GeneraChargeStore';

const {RangePicker} = DatePicker;

@observer
class GeneraChargeFilterFrom extends React.Component {
    render() {
        let numberStyle = {fontSize: '16px', fontWeight: '600', marginLeft: '15px', float: 'right'}
        let tipStyle = {marginLeft: '5px'}
        let genAmount = '代充总额';
        return (
            <Row type={"flex"} style={{flex: '1'}}>
                {<Col style={{lineHeight: '34px'}}>
                    <MySearchComponent
                        defaultValue={{
                            nick_name: filter_store.nick_name ? filter_store.nick_name : '',
                            pet_name: filter_store.pet_name ? filter_store.pet_name : '',
                            agent: filter_store.agent ? filter_store.agent : '',
                            search: filter_store.search ? filter_store.search : '',
                            date: filter_store.start_time != undefined ? [filter_store.start_time, filter_store.end_time] : []
                        }}
                        onClick={(values) => {
                            let pet_name = values.pet_name;
                            let agent = values.agent;
                            let search = values.search;
                            if (pet_name === '') {
                                pet_name = undefined
                            }
                            if (agent === '') {
                                agent = undefined
                            }
                            let filter = {
                                nick_name: filter_store.nick_name,
                                pet_name: filter_store.pet_name,
                                agent: agent,
                                search: search,
                                type_time: values.type_time,
                            }
                            Genera_store.reloadDatas(filter);
                        }}
                    />
                </Col>
                }
                <Col
                    style={{lineHeight: '34px', marginLeft: '10px', flex: 1, textAlign: 'right'}}>
                    <span style={numberStyle}>{Number(Genera_store.sumInMoney).toFixed(2)}</span>
                    <span style={tipStyle}> {genAmount} </span>
                </Col>
            </Row>
        );
    }
}

export default GeneraChargeFilterFrom;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/Statistic/GeneraCharge/GeneraChargeFilterFrom.jsx